import { ReactNode } from "@tanstack/react-router";
import { FC, useContext } from "react";
import { NextPrevContext } from "../../context/nextContext";

export interface NextPrevBarProps {
  middleComponent?: ReactNode
}

export const NextPrevButtonsBar: FC<NextPrevBarProps> = ({middleComponent}) => {
  const { next, prev } = useContext(NextPrevContext);

  return (
    <div className="flex w-full justify-between p-3 box-border items-center">
      <button className="button" onClick={prev}>
        {"<"}
      </button>
      {middleComponent}
      <button className="button" onClick={next}>
        {">"}
      </button>
    </div>
  );
};
